import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const getAuctionEvents = createAsyncThunk(
  "event/getAuctionEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/Settings/GetAuctionEvents_V2?Page_Number=1&Page_Size=100&Sort_Order=desc`
      );
      const data = response?.data?.auctionEvents?.auctionList?.filter(
        (res) => res.eventStatus !== "Did Not Run"
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching auction events"
      );
    }
  }
);

export const getEventAttendees = createAsyncThunk(
  "event/getEventAttendees",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const selectedEventId = state.event.selectedEventId;
      const accounts = state.user.selectedUserData.accounts.map(
        (account) => account.accountId
      );
      const response = await axiosInstance.get(
        `/v1/Event/GetAttendeeList?Event_ID=${selectedEventId}`
      );
      const attendees = response.data;
      const filteredAttendees = attendees.filter((attendee) =>
        accounts.includes(attendee.account_ID)
      );
      return filteredAttendees;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching event attendees"
      );
    }
  }
);

export const getEventAttendeesForSearch = createAsyncThunk(
  "event/getEventAttendeesForSearch",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const selectedEventId = state.event.selectedEventId;
      
      const response = await axiosInstance.get(
        `/v1/Event/GetAttendeeList?Event_ID=${selectedEventId}`
      );
      
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching event attendees"
      );
    }
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState: {
    events: [],
    status: "idle",
    error: null,
    loading: false,
    selectedEvent: null,
    selectedEventId: null,
    selectedEventName: null,
    eventAttendeesList: [],
    eventAttendeesListLoading: false,
    eventAttendeesListForSearch: [],
  },
  reducers: {
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
      state.selectedEventId = action.payload?.value;
      state.selectedEventName = action.payload?.label;
    },
    setEventAttendeesListForSearch: (state, action) => {
      state.eventAttendeesListForSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuctionEvents.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(getAuctionEvents.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.events = action.payload;
        state.loading = false;
      })
      .addCase(getAuctionEvents.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(getEventAttendees.pending, (state) => {
        state.eventAttendeesListLoading = true;
      })
      .addCase(getEventAttendees.fulfilled, (state, action) => {
        state.eventAttendeesList = action.payload;
        state.eventAttendeesListLoading = false;
      })
      .addCase(getEventAttendees.rejected, (state, action) => {
        state.eventAttendeesListLoading = false;
      })
      .addCase(getEventAttendeesForSearch.fulfilled, (state, action) => {
        state.eventAttendeesListForSearch = action.payload;
      });
  },
});

export const { setSelectedEvent, setEventAttendeesListForSearch } = eventSlice.actions;
export default eventSlice.reducer;
